import React from "react";
import { useNavigate } from "react-router-dom";
import EventForm from "./EventForm";
import { ShortfyEvent } from "../../types/event.types";
import { useNotification } from "../../context/NotificationContext";
import "./CreateEventPage.css";

const CreateEventPage: React.FC = () => {
  const navigate = useNavigate();
  const { setNotification } = useNotification();

  const handleSuccess = (event: ShortfyEvent) => {
    setNotification({
      type: "success",
      message: `Event "${event.eventName}" created successfully!`,
    });
    navigate("/cgi-events");
  };

  const handleCancel = () => {
    navigate("/cgi-events");
  };

  return (
    <div className="create-event-container">
      <div className="create-event-content">
        <h1 className="create-event-title">Create Event</h1>
        <EventForm onSuccess={handleSuccess} onCancel={handleCancel} />
      </div>
    </div>
  );
};

export default CreateEventPage;
